import { Game } from './types';

// Generate mock games with different types, difficulties, and standards
export const mockGames: Game[] = [
  // Arcade Games
  {
    id: 'game-001',
    title: 'Fraction Racer',
    primaryStandardId: 'standard-010', // 4.NF.A.1
    gradeLevel: '4',
    difficulty: 'Medium',
    type: 'Arcade',
    theme: 'Racing',
    thumbnail: 'https://placehold.co/300x200/4a89dc/ffffff?text=Fraction+Racer',
    supportedStandards: ['standard-010', 'standard-011'] // Fractions standards
  },
  {
    id: 'game-002',
    title: 'Math Blaster',
    primaryStandardId: 'standard-008', // 3.OA.A.1
    gradeLevel: '3',
    difficulty: 'Easy',
    type: 'Arcade',
    theme: 'Space',
    thumbnail: 'https://placehold.co/300x200/da4453/ffffff?text=Math+Blaster',
    supportedStandards: ['standard-008', 'standard-009'] // Multiplication standards
  },
  {
    id: 'game-003',
    title: 'Number Ninja',
    primaryStandardId: 'standard-007', // 2.NBT.A.1
    gradeLevel: '2',
    difficulty: 'Hard',
    type: 'Arcade',
    theme: 'Ninja',
    thumbnail: 'https://placehold.co/300x200/8cc152/ffffff?text=Number+Ninja',
    supportedStandards: ['standard-006', 'standard-007'] // Number standards
  },
  
  // Puzzle Games
  {
    id: 'game-004',
    title: 'Fraction Puzzler',
    primaryStandardId: 'standard-010', // 4.NF.A.1
    gradeLevel: '4',
    difficulty: 'Medium',
    type: 'Puzzle',
    theme: 'Blocks',
    thumbnail: 'https://placehold.co/300x200/967adc/ffffff?text=Fraction+Puzzler',
    supportedStandards: ['standard-010', 'standard-011'] // Fractions standards
  },
  {
    id: 'game-005',
    title: 'Pattern Detective',
    primaryStandardId: 'standard-003', // K.CC.A.3
    gradeLevel: 'K',
    difficulty: 'Easy',
    type: 'Puzzle',
    theme: 'Mystery',
    thumbnail: 'https://placehold.co/300x200/f6bb42/ffffff?text=Pattern+Detective',
    supportedStandards: ['standard-001', 'standard-002', 'standard-003'] // Counting standards
  },
  {
    id: 'game-006',
    title: 'Decimal Quest',
    primaryStandardId: 'standard-012', // 5.NBT.A.1
    gradeLevel: '5',
    difficulty: 'Hard',
    type: 'Puzzle',
    theme: 'Fantasy',
    thumbnail: 'https://placehold.co/300x200/37bc9b/ffffff?text=Decimal+Quest',
    supportedStandards: ['standard-012', 'standard-013'] // Decimal standards
  },
  
  // Quiz Games
  {
    id: 'game-007',
    title: 'Math Champions',
    primaryStandardId: 'standard-014', // 6.RP.A.1
    gradeLevel: '6',
    difficulty: 'Medium',
    type: 'Quiz',
    theme: 'Sports',
    thumbnail: 'https://placehold.co/300x200/3bafda/ffffff?text=Math+Champions',
    supportedStandards: ['standard-014', 'standard-015'] // Ratio standards
  },
  {
    id: 'game-008',
    title: 'Fraction Face-Off',
    primaryStandardId: 'standard-011', // 4.NF.A.2
    gradeLevel: '4',
    difficulty: 'Medium',
    type: 'Quiz',
    theme: 'Competition',
    thumbnail: 'https://placehold.co/300x200/d770ad/ffffff?text=Fraction+Face-Off',
    supportedStandards: ['standard-010', 'standard-011'] // Fractions standards
  },
  {
    id: 'game-009',
    title: 'Math Showdown',
    primaryStandardId: 'standard-006', // 2.OA.A.1
    gradeLevel: '2',
    difficulty: 'Easy',
    type: 'Quiz',
    theme: 'Western',
    thumbnail: 'https://placehold.co/300x200/e9573f/ffffff?text=Math+Showdown',
    supportedStandards: ['standard-006', 'standard-007'] // Addition standards
  },
  
  // Sorting Games
  {
    id: 'game-010',
    title: 'Shape Sorter',
    primaryStandardId: 'standard-013', // 5.NBT.A.2
    gradeLevel: '5',
    difficulty: 'Easy',
    type: 'Sorting',
    theme: 'Geometric',
    thumbnail: 'https://placehold.co/300x200/4fc1e9/ffffff?text=Shape+Sorter',
    supportedStandards: ['standard-012', 'standard-013'] // Place value standards
  },
  {
    id: 'game-011',
    title: 'Number Sorter',
    primaryStandardId: 'standard-002', // K.CC.A.2
    gradeLevel: 'K',
    difficulty: 'Easy',
    type: 'Sorting',
    theme: 'Basic',
    thumbnail: 'https://placehold.co/300x200/ac92ec/ffffff?text=Number+Sorter',
    supportedStandards: ['standard-001', 'standard-002', 'standard-003'] // Counting standards
  },
  {
    id: 'game-012',
    title: 'Operation Sorter',
    primaryStandardId: 'standard-008', // 3.OA.A.1
    gradeLevel: '3',
    difficulty: 'Medium',
    type: 'Sorting',
    theme: 'Factory',
    thumbnail: 'https://placehold.co/300x200/ffce54/ffffff?text=Operation+Sorter',
    supportedStandards: ['standard-008', 'standard-009'] // Operation standards
  },
  
  // Drag And Drop Sorting Games
  {
    id: 'game-013',
    title: 'Fraction Builder',
    primaryStandardId: 'standard-010', // 4.NF.A.1
    gradeLevel: '4',
    difficulty: 'Hard',
    type: 'DragAndDropSorting',
    theme: 'Construction',
    thumbnail: 'https://placehold.co/300x200/a0d468/ffffff?text=Fraction+Builder',
    supportedStandards: ['standard-010', 'standard-011'] // Fractions standards
  },
  {
    id: 'game-014',
    title: 'Equation Designer',
    primaryStandardId: 'standard-005', // 1.OA.A.2
    gradeLevel: '1',
    difficulty: 'Medium',
    type: 'DragAndDropSorting',
    theme: 'Blueprint',
    thumbnail: 'https://placehold.co/300x200/5d9cec/ffffff?text=Equation+Designer',
    supportedStandards: ['standard-004', 'standard-005'] // Equation standards
  },
  {
    id: 'game-015',
    title: 'Place Value Placer',
    primaryStandardId: 'standard-007', // 2.NBT.A.1
    gradeLevel: '2',
    difficulty: 'Easy',
    type: 'DragAndDropSorting',
    theme: 'Classroom',
    thumbnail: 'https://placehold.co/300x200/ed5565/ffffff?text=Place+Value+Placer',
    supportedStandards: ['standard-006', 'standard-007'] // Place value standards
  },
  
  // Games for other grade levels
  {
    id: 'game-016',
    title: 'Multiplication Master',
    primaryStandardId: 'standard-009', // 3.OA.A.2
    gradeLevel: '3',
    difficulty: 'Medium',
    type: 'Arcade',
    theme: 'Adventure',
    thumbnail: 'https://placehold.co/300x200/fc6e51/ffffff?text=Multiplication+Master',
    supportedStandards: ['standard-008', 'standard-009'] // Multiplication standards
  },
  {
    id: 'game-017',
    title: 'Number Line Jumper',
    primaryStandardId: 'standard-004', // 1.OA.A.1
    gradeLevel: '1',
    difficulty: 'Easy',
    type: 'Arcade',
    theme: 'Platformer',
    thumbnail: 'https://placehold.co/300x200/48cfad/ffffff?text=Number+Line+Jumper',
    supportedStandards: ['standard-004', 'standard-005'] // Addition standards
  },
  {
    id: 'game-018',
    title: 'Division Defender',
    primaryStandardId: 'standard-009', // 3.OA.A.2
    gradeLevel: '3',
    difficulty: 'Hard',
    type: 'Arcade',
    theme: 'Defense',
    thumbnail: 'https://placehold.co/300x200/ec87c0/ffffff?text=Division+Defender',
    supportedStandards: ['standard-008', 'standard-009'] // Division standards
  },
  {
    id: 'game-019',
    title: 'Geometry Explorer',
    primaryStandardId: 'standard-014', // 6.RP.A.1
    gradeLevel: '6',
    difficulty: 'Medium',
    type: 'Puzzle',
    theme: 'Exploration',
    thumbnail: 'https://placehold.co/300x200/5d9cec/ffffff?text=Geometry+Explorer',
    supportedStandards: ['standard-014', 'standard-015'] // Geometry standards
  },
  {
    id: 'game-020',
    title: 'Counting Safari',
    primaryStandardId: 'standard-001', // K.CC.A.1
    gradeLevel: 'K',
    difficulty: 'Easy',
    type: 'DragAndDropSorting',
    theme: 'Animal',
    thumbnail: 'https://placehold.co/300x200/ffce54/ffffff?text=Counting+Safari',
    supportedStandards: ['standard-001', 'standard-002'] // Counting standards
  }
]; 